<template>
  <el-date-picker
    :picker-options="pickerOptions"
    :type="type"
    :size="size"
    :value="value"
    @input="emitInput"
    placeholder="请选择日期"
    format="yyyy年MM月dd日">
  </el-date-picker>
</template>

<script>
import moment from 'moment'

export default {
  name: 'FwDatepicker',
  props: {
    type: {
      type: String,
      default: 'date'
    },
    size: {
      type: String,
      default: 'medium'
    },
    value: {
      type: [Number, String],
      default: '',
      required: true
    },
    pickerOptions: {
      type: Object
    }
  },
  data () {
    return {}
  },
  methods: {
    emitInput (date = '') {
      this.$emit('input', moment(date).endOf('day').unix() * 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/FwDatePicker.vue